<template>
    <div v-show="loginShow">
        <div class="login_modal" @click="closeDialog()"></div>
        <div class="login_content">
            <div class="login_bg"></div>
            <div class="login_body">
                <div class="phone">
                    <input type="text" placeholder="您的手机号" v-model="phoneNumber" />
                </div>

                <div class="img">
                    <input type="text" placeholder="图形验证码" v-model="imgCode" />
                    <img :src="imgSrc" alt @click="getImgcode" />
                </div>
                <div class="sms">
                    <input type="text" placeholder="短信验证码" v-model="smsCode" maxlength="4"/>
                    <span @click="getSmsCode()">{{codeMsg}}</span>
                </div>
                <div class="btn" @click="login()">登录</div>
            </div>
            <div class="close" @click="closeDialog()">
                <img src="../assets/img/closeimg.png" alt class="close_img" />
            </div>
        </div>
        <tipDrawer :showthis.sync="showthis" :showtext.sync="showtext"></tipDrawer>
    </div>
</template>
<script>
import tipDrawer from "./tipDrawer";
export default {
    components: {
        tipDrawer
    },
    data() {
        return {
            loginShow: false,
            phoneNumber: "", //手机号

            imgId: "", //图形验证码ID
            imgCode: "", //图形验证码CODE
            imgSrc: "", //图形验证码链接
            smsCode: "", //短信验证码CODE
            smsId: "",
            timer: "", //获取短信倒计时计时器
            codeMsg: "获取",
            showthis: false,
            showtext: ""
        };
    },
    methods: {
        closeDialog() {
            this.loginShow = !this.loginShow;
        },
        // 获取图形验证码
        getImgcode() {
            this.$axios
                .post(
                    "//mapi.hiweixiu.com/v2/verify/img/code",
                    this.$qs.stringify({ img_id: this.imgId })
                )
                .then(res => {
                    if (res.data.code == 200) {
                        this.imgSrc = res.data.data.data;
                        this.imgId = res.data.data.id;
                    }
                });
        },
        // 倒计时
        changecontent() {
            var time = 60;
            this.timer = setInterval(() => {
                time--;
                this.codeMsg = time + "s";
                // this.isdisabled = true;
                if (time <= 0) {
                    clearInterval(this.timer);
                    this.codeMsg = "获取";
                }
            }, 1000);
        },
        // 得到短信验证码
        getSmsCode() {
            console.log("111");
            if( this.phoneNumber == ""){
                this.showthis = true;
                this.showtext = "请输入手机号";
                return;
            }
            if(this.imgCode.length != 4){
                this.showthis = true;
                this.showtext = "请输入图形验证码";
                return;
            }
            if(this.codeMsg != '获取'){
                return;
            }
            var params = {
                phone_number: parseInt(this.phoneNumber),
                sms_id: this.smsId,
                img_code: parseInt(this.imgCode),
                img_id: this.imgId
            };
            this.$axios
                .post("//mapi.hiweixiu.com/v2/verify/sms/code", params)
                .then(res => {
                    if (res.data.code == 200) {
                        this.smsId = res.data.data.id;
                        this.changecontent();
                    } else {
                        this.showthis = true;
                        this.showtext = res.data.msg;
                        this.getImgcode();
                        this.imgCode = "";
                        return;
                    }
                });
        },
        // 判断是否是隐身模式
        storageTest() {
            var storage = window.localStorage;
            storage.setItem("key", "value");
            if (storage.getItem("key") == "value") {
                return true;
            } else {
                return false;
            }
        },
        // 存localStorage或者sessionStorage
        writeStorage(key, value) {
            localStorage.setItem(key, value);
            if (this.storageTest()) {
                localStorage.setItem(key, value);
            } else {
                sessionStorage.setItem(key, value);
            }
        },
        // 登录接口
        login() {
            if( this.phoneNumber == ""){
                this.showthis = true;
                this.showtext = "请输入手机号";
                return;
            }
            if( this.smsCode == ""){
                this.showthis = true;
                this.showtext = "请输入短信验证码";
                return;
            }
            var postData = {
                phone: parseInt(this.phoneNumber),
                verification_code: parseInt(this.smsCode)
            };
            var that = this;
            $.ajax({
                type: "POST",
                url: "//mapi.hiweixiu.com/v1/user/login",
                data: postData,
                success: function(res) {
                   if (res.code == 200) {
                        that.writeStorage("tel", that.phoneNumber);
                        that.writeStorage("username", res.data.token);
                        that.$parent.phone_number = that.phoneNumber;
                        that.$parent.username = res.data.token;
                        that.username = res.data.token;
                        that.loginShow = false;
                    } else {
                        that.getImgcode();
                        that.showthis = true;
                        that.showtext = res.msg;
                    }
                },
                error: function(e) {
                    console.log(e);
                    return false;
                }
            });
            // this.$axios
            //     .post("//mapi.hiweixiu.com/v1/user/login", postData)
            //     .then(res => {
            //         if (res.data.code == 200) {
            //             this.writeStorage("tel", this.phoneNumber);
            //             this.writeStorage("username", res.data.data.token);
            //             this.$parent.phone_number = this.phoneNumber;
            //             this.$parent.username = res.data.data.token;
            //             this.username = res.data.data.token;
            //             this.loginShow = false;
            //         } else {
            //             this.getImgcode()
            //         }
            //         this.loginStatus = true;
            //         this.showthis = true;
            //         this.showtext = res.data.msg;
            //     })
            //     .catch(err => {
            //          this.showthis = true;
            //             this.showtext = "登录异常";
            //     });
        }
    },
    mounted() {
        this.getImgcode();
    }
};
</script>
<style lang="scss" scoped>
.login_modal {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
}
.login_content {
    position: fixed;
    top: 20%;
    left: 50%;
    transform: translateX(-50%);
    width: 260px;
    padding: 34px 22px 22px;
    background: #fff;
    border-radius: 4px;
    .login_bg {
        position: absolute;
        top: -10px;
        left: 50%;
        transform: translateX(-50%);
        height: 33px;
        width: 100px;
        background: url(../assets/flashsaleimg/loginbg.png) center no-repeat;
        background-size: 100px 33px;
    }
    .phone,
    .img,
    .sms {
        margin-bottom: 10px;
        border: 1px solid #eee;
        border-radius: 4px;
        font-size: 12px;
        height: 36px;
        display: flex;
        display: flex;
        justify-content: space-between;
        align-items: center;
        overflow: hidden;
    }
    .sms input,
    .img input,
    .phone input {
        margin: 8px 5px;
    }
    .sms input,
    .img input {
        width: 100px;
    }
    .img img {
        height: 34px;
    }
    .sms span {
        width: 64px;
        text-align: center;
    }
    .close {
        .close_img {
            position: absolute;
            right: 0;
            top: -30px;
            width: 22px;
        }
    }
    .btn {
        margin-top: 20px;
        height: 36px;
        width: 100%;
        font-size: 14px;
        line-height: 36px;
        text-align: center;
        color: #ffffff;
        background: linear-gradient(90deg, #ff854d 0%, #ff5000 100%);
        border-radius: 4px;
    }
}
</style>